export default "__VITE_ASSET__B$w236bn__"